import type { SVGProps } from 'react';
const DawnFlagDZ = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-DZ_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-DZ_svg__a)">
      <path fill="#048345" d="M0 16h11.524V0H0z" />
      <path
        fill="#E81B42"
        d="m13.619 8.832-1.232.894.454-1.469-1.215-.916 1.512-.014.48-1.46.481 1.46 1.512.014-1.215.916.454 1.469z"
      />
      <path
        fill="#E81B42"
        d="M13.892 11.505c-.808.803-1.894 1.295-3.087 1.295-2.496 0-4.519-2.15-4.519-4.8s2.023-4.8 4.519-4.8c1.193 0 2.28.492 3.087 1.295a4.24 4.24 0 0 0-1.855-.422C9.768 4.073 7.929 5.83 7.929 8s1.84 3.927 4.108 3.927c.667 0 1.298-.152 1.855-.422"
      />
    </g>
  </svg>
);
export default DawnFlagDZ;
